// extracted by mini-css-extract-plugin
export var headerCell = "_4j-1";
export var loadingSpinnerContainer = "_4j-4";
export var rowWrapper = "_4j-3";
export var standaloneTable = "_4j-5";
export var table = "_4j-0";
export var white = "_4j-2";